import { useRef } from "react";

import Footer from "@/base/Footer";
import { FilterPanel } from "@/search/NewSearchPageMVP/FilterPanel";
import { SearchResults } from "@/search/NewSearchPageMVP/SearchResults";
import { ContentTypeFilter } from "./ContentTypeFilter";
import {
  footerCss,
  mainContentsContainerCss,
  mainContentsFlexColumnCss,
  searchPageContainerCss,
} from "./NewSearchPageMVP.styles";
import { SearchContentSettings } from "./SearchContentSettings";

export const NewSearchPageMVP = () => {
  const filterPanelRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <div css={searchPageContainerCss}>
        <FilterPanel ref={filterPanelRef} />

        <div css={mainContentsContainerCss}>
          <div css={mainContentsFlexColumnCss}>
            <ContentTypeFilter />
            <SearchResults />
          </div>

          <Footer customCss={footerCss} />
        </div>
      </div>
      <SearchContentSettings />
    </>
  );
};
